// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-dialog-container {
  width: 380px;
  height: 440px;
  opacity: 1;
  position: absolute;
  left: calc(50% - 190px);
  top: calc(50% - 220px);
  z-index: 10;
  animation: popup 0.1s ease-in-out 0s 1;
  border-radius: 5px;
  padding: 22px 20px 16px;
  box-sizing: border-box;
}
.edit-dialog-title {
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 16px;
}
/* Generic row layout */
.edit-dialog-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
}
.edit-dialog-row-description {
  align-items: flex-start;
}
.edit-dialog-label {
  font-size: 14px;
  width: 40px;
  min-width: 50px;
  flex-shrink: 0;
  text-align: right;
  margin-right: 10px;
  line-height: 32px;
}
.edit-dialog-input {
  flex: 1 1;
  height: 32px;
  box-sizing: border-box;
  padding-left: 8px;
  font-size: 14px;
  border-radius: 5px;
  appearance: none;
  border: 2px solid rgba(75, 75, 75, 1);
  outline: none;
  background: transparent;
}
.edit-dialog-textarea {
  flex: 1 1;
  box-sizing: border-box;
  padding: 6px 8px;
  font-size: 14px;
  border-radius: 5px;
  resize: vertical;
  min-height: 64px;
  line-height: 1.4;
  font-family: inherit;
  appearance: none;
  border: 2px solid rgba(75, 75, 75, 1);
  outline: none;
  background: transparent;
}
/* Cover picker */
.edit-dialog-cover-box {
  flex: 1 1;
  height: 100px;
  border-radius: 5px;
  border: 2px dashed rgba(75, 75, 75, 1);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: border-color 0.15s;
}
.edit-dialog-cover-box:hover {
  border-color: rgba(75, 75, 75, 1);
}
.edit-dialog-cover-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.edit-dialog-cover-placeholder {
  font-size: 13px;
  color: #aaa;
  padding: 8px;
  text-align: center;
}
/* Button row */
.edit-dialog-button-container {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/editDialog/editDialog.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAElB,gBAAgB;EAChB,qCAAqC;EACrC,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,SAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EAEpB,gBAAgB;EAChB,qCAAqC;EACrC,aAAa;EACb,uBAAuB;AACzB;AACA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA,eAAe;AACf;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".edit-dialog-container {\n  width: 380px;\n  height: 440px;\n  opacity: 1;\n  position: absolute;\n  left: calc(50% - 190px);\n  top: calc(50% - 220px);\n  z-index: 10;\n  animation: popup 0.1s ease-in-out 0s 1;\n  border-radius: 5px;\n  padding: 22px 20px 16px;\n  box-sizing: border-box;\n}\n.edit-dialog-title {\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n  margin-bottom: 16px;\n}\n/* Generic row layout */\n.edit-dialog-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  width: 100%;\n}\n.edit-dialog-row-description {\n  align-items: flex-start;\n}\n.edit-dialog-label {\n  font-size: 14px;\n  width: 40px;\n  min-width: 50px;\n  flex-shrink: 0;\n  text-align: right;\n  margin-right: 10px;\n  line-height: 32px;\n}\n.edit-dialog-input {\n  flex: 1;\n  height: 32px;\n  box-sizing: border-box;\n  padding-left: 8px;\n  font-size: 14px;\n  border-radius: 5px;\n  -webkit-appearance: none;\n  appearance: none;\n  border: 2px solid rgba(75, 75, 75, 1);\n  outline: none;\n  background: transparent;\n}\n.edit-dialog-textarea {\n  flex: 1;\n  box-sizing: border-box;\n  padding: 6px 8px;\n  font-size: 14px;\n  border-radius: 5px;\n  resize: vertical;\n  min-height: 64px;\n  line-height: 1.4;\n  font-family: inherit;\n  -webkit-appearance: none;\n  appearance: none;\n  border: 2px solid rgba(75, 75, 75, 1);\n  outline: none;\n  background: transparent;\n}\n/* Cover picker */\n.edit-dialog-cover-box {\n  flex: 1;\n  height: 100px;\n  border-radius: 5px;\n  border: 2px dashed rgba(75, 75, 75, 1);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  transition: border-color 0.15s;\n}\n.edit-dialog-cover-box:hover {\n  border-color: rgba(75, 75, 75, 1);\n}\n.edit-dialog-cover-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.edit-dialog-cover-placeholder {\n  font-size: 13px;\n  color: #aaa;\n  padding: 8px;\n  text-align: center;\n}\n/* Button row */\n.edit-dialog-button-container {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
